import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService, { emailBody, phoneBody } from '../../../base/services/authService';
import './loginPage.scss';
import { PhoneInput } from "react-international-phone";
import RsaBase from '../../../base/netWork/RsaBase';
import ForgetView from './views/ForgetView';
import { message } from 'antd';
import useUserData from '../../../base/hooks/useUserData';
import { EyeOutlined, EyeInvisibleOutlined, LeftOutlined } from '@ant-design/icons';
import { EmailUtil } from '../../../common/EmailUtil';

// 手机适配
import '../../phone/appointmentManagement/login/login.scss';
interface LoginForm {
    email: string;
    phone: string;
    zone: string;
    enablePhone: boolean;
    password: string;
}

type LoginType = 'email' | 'phone';

type ViewName = "" | "forget" | "signup";

export default function LoginPage() {

    const navigate = useNavigate();
    const { userData, loginStatus } = useUserData();
    useEffect(() => {
        if (loginStatus == 1) {
            if (userData?.is_user && userData?.is_user > 1) {
                navigate("/appointmentManagement/dashboard");
            } else {
                navigate("/");
            }
        }
    }, [loginStatus]);
    const [viewName, setViewName] = useState<ViewName>("");
    const [isMobileType, setIsMobileType] = useState(false);
    useEffect(() => {
        const isMobileType = /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
        if(isMobileType){
            setIsMobileType(true);
        }else{
            setIsMobileType(false);
        }
    }, []);
    return (
        <div className="user-login-page">
            {/* <div className="user-login-page-left-box"> */}
                {/* <img src={require('../../../assets/user/login/login_left.png')} /> */}
            {/* </div> */}

            <div className="user-login-page-right-box">
                <div className="login-logo">
                    <img src={require('../../../assets/appointmentManagement/login/logo.png')} alt="logo" />
                </div>
                <div className="login-title">
                    Welcome to Appointment Management
                </div>
                {
                    viewName === "" && <UserLoginView setViewName={setViewName} isMobileType={isMobileType} />
                }
            </div>
        </div>
    );
}


function UserLoginView({ setViewName, isMobileType }: { setViewName: (viewName: ViewName) => void, isMobileType: boolean }) {
    const navigate = useNavigate();

    const [formData, setFormData] = useState<LoginForm>({
        email: '',
        phone: '',
        enablePhone: false,
        zone: '',
        password: ''
    });

    const [loginType, setLoginType] = useState<LoginType>('email');
    const [isLoading, setIsLoading] = useState(false);
    const [enableSubmit, setEnableSubmit] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [phoneInputFocus, setPhoneInputFocus] = useState(false);


    const handlePasswordChange = (password: string) => {
        setFormData(prev => ({
            ...prev,
            password: password
        }));
    }

    useEffect(() => {
        const enablePassword = formData.password.length >= 6;
        const enablePhone = formData.enablePhone;
        const isPhone = formData.phone.replace(formData.zone, '') ? true : false;
        const enableEmail = EmailUtil.checkEmailFormat(formData.email.trim());
        // setEnableSubmit(enablePhone && enablePassword);
        setEnableSubmit((loginType === 'phone' ? isPhone : enableEmail) && enablePassword);//不验证电话号码是否正确
    }, [formData, loginType]);
    // 处理手机号变化
    const handlePhoneChange = (phone: string, mate: any) => {
        const zone = "+" + mate.country.dialCode;
        const mobile = phone; //phone.replace(zone, '');
        const input = mate.inputValue.replace(`+${mate.country.dialCode} `, "");
        if (mate.country.format === undefined || input === undefined) {
            return;
        }
        const enablePhone = input.length === mate.country.format.length;
        setFormData(prev => ({
            ...prev,
            phone: mobile,
            zone: zone,
            enablePhone: enablePhone
        }));
    };
    // 处理表单提交
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!enableSubmit) {
            return;
        }

        setIsLoading(true);
        try {
            const password = RsaBase.encryptData(formData.password) || '';
            let response;
            if (loginType === 'email') {
                const loginRequest: emailBody = {
                    email: formData.email.trim(),
                    password: password
                };
                response = await authService.emailLogin(loginRequest);
            } else {
                const loginRequest: phoneBody = {
                    zone: formData.zone.replace('+', ''),
                    mobile: formData.phone.replace(formData.zone, ''),
                    password: password
                };
                response = await authService.phoneLogin(loginRequest);
            }
            if (response.success) {
                const userData = await authService.loadCurrentUser();
                if (userData?.is_user && userData?.is_user > 1) {
                    navigate("/appointmentManagement/dashboard");
                } else {
                    messageApi.error("No permission");
                }
            } else {
                messageApi.error(response.message);
            }
        } catch (error: any) {
            console.error("登录失败:", error);
            messageApi.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const [messageApi, contextHolder] = message.useMessage();
    return <div className="user-login-content">
        {contextHolder}
        <div className="user-login-content-header">
            Login your account
        </div>
        <form className="user-login-content-form" onSubmit={handleSubmit}>
            {loginType === 'phone' ? <div className="form-group">
                <label htmlFor="phoneNumber">Phone Number</label>
                    <PhoneInput
                        defaultCountry="my"
                        value={formData.phone}
                        onChange={handlePhoneChange}
                        onFocus={() => {
                            setPhoneInputFocus(true);
                        }}
                        onBlur={() => {
                            setPhoneInputFocus(false);
                        }}
                        placeholder="Enter your phone number"
                        className={`phone-input-container ${phoneInputFocus ? 'input-focus' : ''}`}
                        countrySelectorStyleProps={{
                            buttonClassName: 'country-selector'
                        }}
                        hideDropdown={true}
                        // 自定义按钮样式
                        inputProps={{
                            className: 'phone-input'
                        }}
                    />
            </div> : <div className="form-group">
                <label htmlFor="email">Email</label>
                <div className="email-input-container">
                    <input
                        id="email"
                        type="email"
                        placeholder="Enter Your Email Address"
                        value={formData.email}
                        onChange={(e) => setFormData(prev => ({
                            ...prev,
                            email: e.target.value
                        }))}
                        autoComplete="email"
                    />
                </div>
            </div>}

            <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="password-input-container">
                    <input
                        id="password"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter Your Password"
                        value={formData.password}
                        onChange={(e) => handlePasswordChange(e.target.value)}
                        autoComplete="current-password"
                    />
                    <div className="password-input-container-eye" onClick={() => {
                        setShowPassword(!showPassword);
                    }}>
                        {showPassword ? <EyeOutlined
                            style={{
                                color: 'rgba(145, 145, 146, 1)',
                                fontSize: '20px'
                            }}
                         /> : <EyeInvisibleOutlined
                            style={{
                                color: 'rgba(145, 145, 146, 1)',
                                fontSize: '20px'
                            }}
                          />}
                    </div>
                </div>
            </div>
            {/* <div className="user-login-content-forgot-password">
                <a href="#forgot-password" onClick={() => setViewName("forget")}>Forgot Password?</a>
            </div> */}
            <button
                type="button"
                className="user-login-content-switch-login-type"
                onClick={() => setLoginType(loginType === 'phone' ? 'email' : 'phone')}
                disabled={isLoading}
            >
                {/* {loginType === 'phone' ? 'Sign In With Email' : 'Sign In With Phone Number'} */}
            </button>
            <button
                type="submit"
                className={`user-login-content-submit ${isLoading ? 'loading' : ''} ${enableSubmit ? '' : 'disabled'}`}
                disabled={isLoading || !enableSubmit}
            >
                {isLoading ? 'Signing in...' : 'Sign In'}
            </button>
        </form>
    </div>
}
